// 武装部
export default [
    {
        path: '/arms/militaryTrainingVideoCount',
        component: resolve => require(['@/pages/arms/militaryTrainingVideoCount.vue'], resolve),
        name: 'militaryTrainingVideoCount',
        meta: {
            title: '在线军训成绩'
        }
    },
    {
        path: '/hoistFlag',
        component: resolve => require(['@/pages/arms/hoistFlag'], resolve),
        name: 'hoistFlag',
        meta: {
            title: '升旗预约'
        }
    },
    {
        path: '/hoistFlag/detail',
        component: resolve => require(['@/pages/arms/hoistFlagDetail'], resolve),
        name: 'hoistFlagDetail',
        meta: {
            title: '升旗预约详情'
        }
    },
    {
        path: '/orderHoistFlag',
        component: resolve => require(['@/pages/arms/orderHoistFlag'], resolve),
        name: 'orderHoistFlag',
        meta: {
            title: '升旗预约'
        }
    },
    {
        path: '/armsPublicize',
        component: resolve => require(['@/pages/arms/armsPublicize'], resolve),
        name: 'armsPublicize',
        meta: {
            title: '征兵宣讲预约'
        }
    },
    {
        path: '/orderArmsPublicize',
        component: resolve => require(['@/pages/arms/orderArmsPublicize'], resolve),
        name: 'orderArmsPublicize',
        meta: {
            title: '征兵宣讲预约'
        }
    },
    {
        path: '/armsPublicize/detail',
        component: resolve => require(['@/pages/arms/armsPublicizeDetail'], resolve),
        name: 'armsPublicizeDetail',
        meta: {
            title: '征兵宣讲预约详情'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/arms.js